import * as Yup from "yup";

export const initialValuesFormInstitutions = {
    nombre: "",
    telefono: "",
    direccion: "",
    siglas: ""
}

export const validationSchemaFormInstitutionss = Yup.object().shape({
    nombre: Yup.string().required('El nombre de la institución es requerido.'),
    telefono: Yup.string().optional().typeError("Debe ser un texto valido."),
    direccion: Yup.string().optional(),
    siglas: Yup.string().optional()
})

